import {LauncherProvider} from '@/components/Launcher/Launcher.jsx'
import {ModalManager} from '@/components/Modal/index.mjs'
import {PopoverManager} from '@/components/Popover/index.mjs'
import PreviewImages from '@/components/PreviewImages/PreviewImages.jsx'
import useDocTitle from '@/hooks/useDocTitle.mjs'
import AntDesign from './AntDesign.jsx'
import License from './License.jsx'
import Router from './Router.jsx'
import Sse from './Sse.jsx'
import SwrConfig from './SwrConfig.jsx'
import useBaiduAnalytics from './useBaiduAnalytics.mjs'

const App = () => {
    useBaiduAnalytics()
    // useDocTitle(import.meta.env.VITE_APP_NAME)

    return (
        <AntDesign>
            <SwrConfig>
                <PopoverManager>
                    <ModalManager>
                        <PreviewImages>
                            <LauncherProvider>
                                <License>
                                    <Sse />
                                    <Router />
                                </License>
                            </LauncherProvider>
                        </PreviewImages>
                    </ModalManager>
                </PopoverManager>
            </SwrConfig>
        </AntDesign>
    )
}

export default App
